import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "honeystone_admin_token";
const USER_KEY = "honeystone_admin_user";

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getUser: () => {
    const raw = localStorage.getItem(USER_KEY);
    try { return raw ? JSON.parse(raw) : null; } catch { return null; }
  },
  setSession: (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = auth.getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const photoUrl = (id) => `${API}/photos/${id}`;

export const SERVICES = [
  { id: "lawn_mowing", label: "Lawn Mowing" },
  { id: "strimming", label: "Strimming" },
  { id: "weeding", label: "Weeding" },
  { id: "hedge_trimming", label: "Hedge Trimming" },
  { id: "pressure_washing", label: "Pressure Washing" },
  { id: "handyman", label: "Handyman / General Maintenance" },
  { id: "other", label: "Other" },
];

export const FREQUENCY_LABEL = {
  one_off: "One-off job",
  weekly: "Weekly",
  fortnightly: "Fortnightly",
};

export const WASTE_LABEL = {
  green_bin: "Green council bin (leave on site)",
  remove_dispose: "Honeystone to remove & dispose",
};

export const VISIT_PREFERENCE_LABEL = {
  meet_greet: "Meet & greet — chat & walk-around first",
  do_not_disturb: "Do not disturb — just do the job, invoice later",
};

export const STATUS_META = {
  pending_review: { label: "Pending Review", className: "bg-[#F1ECDC] text-[#7A5A12] border-[#E0D6B0]" },
  quote_ready:    { label: "Quote Ready",    className: "bg-[#E3EBDA] text-[#3C5A3F] border-[#C9D6B7]" },
  accepted:       { label: "Accepted — Awaiting Dates", className: "bg-[#E0E9F0] text-[#2B4A66] border-[#BDD0DD]" },
  dates_offered:  { label: "Dates Offered — Awaiting Pick", className: "bg-[#F1ECDC] text-[#7A5A12] border-[#E0D6B0]" },
  booked:         { label: "Booked",         className: "bg-[#4F6F52] text-white border-[#3C5A3F]" },
  declined:       { label: "Declined",       className: "bg-[#F1DCDC] text-[#8A2C2C] border-[#E0B0B0]" },
};
